var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88135 28.0814H7.1809V11.1872H5.88135C5.19202 11.1872 4.53092 11.461 4.04349 11.9484C3.55606 12.4359 3.28223 13.0969 3.28223 13.7863V25.4823C3.28223 26.1716 3.55606 26.8327 4.04349 27.3202C4.53092 27.8076 5.19202 28.0814 5.88135 28.0814ZM26.6743 11.1872H17.5774L19.0355 6.81024C19.1656 6.41961 19.201 6.00366 19.1389 5.59665C19.0768 5.18964 18.9188 4.80322 18.6781 4.46921C18.4373 4.1352 18.1207 3.86316 17.7542 3.67549C17.3878 3.48783 16.9819 3.38991 16.5702 3.3898H16.2778L9.78002 10.4568V28.0814H24.0752L29.1591 16.9104L29.2734 16.3854V13.7863C29.2734 13.0969 28.9996 12.4359 28.5121 11.9484C28.0247 11.461 27.3636 11.1872 26.6743 11.1872Z",
    fill: "#003049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.68c3a6a39c17f60f9d0ac002ccee0e4f.svg";
export { ForwardRef as ReactComponent };